import { useState, useEffect } from "react";
import { useSelection } from "../../contexts/SelectionContext";

/**
 * A pin at a point. By default the point is the map's selected location
 * (SelectionContext); pass `latlng` to pin somewhere else, e.g. the location
 * of a project being set up on the listing map, where a click on the map
 * must not move it.
 */
const PinLayer = (
  id: string,
  name: string,
  latlng?: { lat: number; lng: number } | null) => {
    const selection = useSelection();
    const selectedLatLng = latlng === undefined ? selection.selectedLatLng : latlng;
    const [stale, setStale] = useState(false);
    const [geojson, setGeojson] = useState<any>(null);

  useEffect(() => {
    // No point yet: an empty collection, not a point with no coordinates.
    const pinGeojson = {
      type: "FeatureCollection",
      features: selectedLatLng
        ? [
            {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: [selectedLatLng.lng, selectedLatLng.lat],
              },
            },
          ]
        : [],
    };
    setGeojson(pinGeojson);
    setStale(true); // Set stale to true when the pin geojson changes
  }, [selectedLatLng]);

  const layerStyle = {
    id: id,
    type: "symbol",
    layout: {
      "icon-image": "pin",
      "icon-size": 0.7,
      "icon-allow-overlap": true,
      "icon-anchor": "bottom",
    },
    paint: {
      "icon-color": "#AF0",
    },
  };

  return {
    id: id,
    name: name,
    source: geojson,
    layerStyle: layerStyle,
    toolbarButton: null,
    active: true,
    stale: stale,
    setStale: setStale,
  };
};

export default PinLayer;